/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/typedef */
import { Enum } from '@shared/shared-utils';

export interface SizeInfo {
  type: string;
  id: number;
  pixel: number | string;
  size?: number | string;
}

export const originalImageSize = [
  {
    type: '原图',
    id: 1,
    pixel: 1,
  },
];

export const allImageSize = [
  ...originalImageSize,
  {
    type: '超清',
    id: 4,
    pixel: 2560,
  },
  {
    type: '高清',
    id: 2,
    pixel: 1024,
  },
  {
    type: '标准',
    id: 3,
    pixel: 800,
  },
];

export const originalVideoSize = [
  {
    type: 'HD',
    id: 4,
    pixel: 1080,
  },
];

export const allVideoSize = [
  {
    type: '4K',
    id: 10,
    pixel: 2160,
  },
  ...originalVideoSize,
];

// 对应接口的 goodsType
export class MediaType extends Enum.Enum {
  static [Enum.META]: {
    label: string;
  };

  @Enum.meta({
    label: '图片',
  })
  static image = 0;

  @Enum.meta({
    label: '视频',
  })
  static video = 1;
}

export class MediaSource extends Enum.Enum {
  static [Enum.META]: {
    label: string;
    sizeList: SizeInfo[];
    type: number;
  };

  @Enum.meta({
    label: '创意图片',
    sizeList: allImageSize,
    type: MediaType.image,
  })
  static creativeImage = 1;

  @Enum.meta({
    label: '编辑图片',
    sizeList: allImageSize,
    type: MediaType.image,
  })
  static editorImage = 2;

  @Enum.meta({
    label: '编辑视频',
    sizeList: allVideoSize,
    type: MediaType.video,
  })
  static editorVideo = 3;
}

export enum SearchType {
  IMAGE = 'image',
  STORY = 'story',
  CREATIVE = 'creative',
  VIDEO = 'video',
  TOPIC = 'topic',
  VIDEO_STORY = 'videostory',
}
